import { ItemList } from "../../orm";
import { http } from "../../lib";

class AdminGalleriesList extends ItemList {

  getEntityKey() {
    return "admin/gallery";
  }
}

class AdminGalleriesProcessingList extends ItemList {

  getEntityKey() {
    return "admin/gallery/check_processing"
  }

  check({galleryId}) {
    return this.saveNewObject({gallery_id: galleryId})
  }
}

class AdminGalleriesFacialRecognitionList extends ItemList {

  getEntityKey() {
    return "admin/gallery/index_gallery_for_facial_recognition"
  }

  index({galleryId}) {
    return this.saveNewObject({gallery_id: galleryId})
  }
}

class AdminGalleriesBibRecognitionList extends ItemList {

  getEntityKey() {
    return "admin/gallery/index_gallery_for_bib_recognition"
  }

  index({galleryId}) {
    return this.saveNewObject({gallery_id: galleryId})
  }
}

class AdminGalleriesProcessGalleryPhotographsList extends ItemList {

  getEntityKey() {
    return "admin/gallery/process_uploaded_photographs"
  }

  process({galleryId}) {
    return this.saveNewObject({gallery_id: galleryId})
  }
}

export const adminGalleriesList = new AdminGalleriesList("admin_galleries__default");
export const adminGalleriesProcessingList = new AdminGalleriesProcessingList("admin_galleries_processing__default");
export const adminGalleriesFacialRecognitionList = new AdminGalleriesFacialRecognitionList("admin_galleries_facial_recognition__default");
export const adminGalleriesBibRecognitionList = new AdminGalleriesBibRecognitionList("admin_galleries_bib_recognition__default");
export const adminGalleriesProcessGalleryPhotographsList = new AdminGalleriesProcessGalleryPhotographsList("admin_galleries_process_gallery_photographs__default");
